import { useContext } from 'react';

import { TwilioContext } from '../../../context-providers/TwilioContext';
import { useRestoreSelectedCall } from '../../../hooks/useRestoreSelectedCall';

/**
 * Hook for CallsPage - handles call restoration
 */
export const useCallsPage = () => {
  const { selectedHistoricalCall, setSelectedHistoricalCall } = useContext(TwilioContext);

  // Restore selected call from localStorage on mount
  useRestoreSelectedCall(selectedHistoricalCall, setSelectedHistoricalCall);
};
